import { SPACE_BUTTONS } from '../_CONSTANTS';
import { keyPressed } from '../keypressed';
/**
 * This will test whether the spacebar key is pressed
 * You must provide it the keyboard event;
 *
 * @since v2.33.0
 * @category Keyboard
 * @param {KeyboardEvent} event keyboard event
 * @returns { boolean } boolean
 * @example
 * // Test whether the the spacebar on the keyboard is pressed
 * spaceKeyPressed(event) //=> true if spacebar pressed
 * @docgen_example
 * const event = { key: 'Space' }; //<-- Object from keyboard event
 * spaceKeyPressed(event);
*/
export var spaceKeyPressed = function (event) { return keyPressed(event, SPACE_BUTTONS); };
